import React from "react";

import { Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import CancelIcon from "@mui/icons-material/Cancel";

import UploadFileIcon from "@mui/icons-material/UploadFile";

import { MeetingJoinType } from "../../../../../types";

import ControlButton from "../../../bars/web-control-bar/components/control-button";
import SelectedVideoTile from "./components/selected-video-tile";
import SendMessageButton from "./components/send-message-button";
import { MeetingInfoContext } from "../../../../../context";

interface RemoteHeadsetVideoProps {
  showCamera?: boolean;
  showUpload?: boolean;
}

const RemoteHeadsetVideo: React.FC<RemoteHeadsetVideoProps> = ({
  showCamera = true,
  showUpload = false,
}) => {
  const { userName, userId } = React.useContext(MeetingInfoContext);

  const [showVideo, setShowVideo] = React.useState<boolean>(true);
  const [canShowVideo, setCanShowVideo] = React.useState<boolean>(false);

  const [remoteVideo, setRemoteVideo] = React.useState<boolean>(true);

  const [canTakePicture, setCanTakePicture] = React.useState<boolean>(true);

  const toggleShowSelf = () => {
    setShowVideo(!showVideo);
  };

  const onCanShowVideo = (canShow: boolean) => {
    setCanShowVideo(canShow);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "fit-content",
        height: "fit-content",
      }}
    >
      <div
        style={{
          display: canShowVideo ? "block" : "none",
          position: "absolute",
          bottom: "1rem",
          left: "1rem",
          width: "20vw",
          maxHeight: "30vh",
          height: "auto",
          zIndex: 100,
        }}
      >
        <div>
          <SelectedVideoTile
            userName={userName}
            type={MeetingJoinType.Headset}
            userId={userId}
            showVideo={showVideo}
            onCanShowVideo={onCanShowVideo}
          />
          <div
            style={{
              position: "absolute",
              bottom: "0rem",
              left: 0,
              right: 0,
              zIndex: 100,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack width={"100%"} direction={"row"} spacing={0.5} sx={{ boxSizing: 'border-box', px: 2, pb: 1, '& > *': { flex: '1 1 33%', minWidth: 0, '& .MuiButton-root': { padding: 0.5 } } }}>
              <ControlButton
                onClick={toggleShowSelf}
                disabled={!canShowVideo}
                activeIcon={<VisibilityIcon color="action" />}
                inactiveIcon={<VisibilityOffIcon color="action" />}
                showText={false}
                active={showVideo && canShowVideo}
                activeLabel={"Hide Headset Video"}
                inactiveLabel={"Show Headset Video"}
              />

              {showCamera && (
                <SendMessageButton
                  topic="camera"
                  id="remote-camera-button"
                  isMaster={false}
                  disabled={!canShowVideo}
                  activeIcon={<VideocamIcon color="action" />}
                  inactiveIcon={<VideocamOffIcon color="action" />}
                  active={remoteVideo && canShowVideo}
                  onClick={setRemoteVideo}
                  activeLabel={"Disable Headset Camera"}
                  inactiveLabel={"Enable Headset Camera"}
                  showText={false}
                />
              )}
              {showUpload && (
                <SendMessageButton
                  topic="upload-image"
                  id="remote-upload-image-button"
                  isMaster={false}
                  disabled={!canShowVideo || !canTakePicture}
                  activeIcon={<UploadFileIcon color="action" />}
                  inactiveIcon={<UploadFileIcon color="action" />}
                  active={canTakePicture && canShowVideo}
                  onClick={setCanTakePicture}
                  activeLabel={"Open Camera to Upload Image"}
                  inactiveLabel={"Cannot Upload Image"}
                  showText={false}
                />
              )}
              <SendMessageButton
                topic="leaveCall"
                id="leave-call-button"
                isMaster={false}
                disabled={false}
                active={true}
                activeIcon={<CancelIcon color="action" />}
                activeLabel={"Disconnect Headset from call."}
                inactiveLabel={"Disconnect Headset from call"}
                activeColor="#c62828"
                onClick={() => {
                  console.log("~~~ Force Disconnect RealWare");
                }}
                showText={false}
              />
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoteHeadsetVideo;
